import {informationUrl} from './informationLinks';
import {useEffect,useRef} from 'react';
import BrandLogo from './BrandLogo';
import './welcome.css';

// A release marker, deliberately independent of routine build/version changes.
const WELCOME_KEY='graffiti:welcome:neighborhoods-v1';
export function welcomeWasDismissed(){try{return localStorage.getItem(WELCOME_KEY)==='dismissed';}catch{return false;}}
export function rememberWelcomeDismissal(){try{localStorage.setItem(WELCOME_KEY,'dismissed');}catch{/* Dismissal still applies for this mounted visit. */}}

export default function Welcome({onClose,onAccount,signedIn=false}:{onClose:()=>void;onAccount:()=>void;signedIn?:boolean}){
 const panel=useRef<HTMLElement>(null),close=useRef(onClose);
 close.current=onClose;
 useEffect(()=>{
  const previous=document.activeElement instanceof HTMLElement?document.activeElement:null;
  panel.current?.focus();
  const key=(event:KeyboardEvent)=>{
   if(event.key==='Escape'){event.preventDefault();event.stopPropagation();close.current();return;}
   if(event.key!=='Tab')return;
   const controls=[...panel.current!.querySelectorAll<HTMLElement>('button:not([disabled]),a[href]')].filter(control=>control.getClientRects().length>0);
   const first=controls[0],last=controls.at(-1);if(!first||!last)return;
   if(event.shiftKey&&(document.activeElement===first||document.activeElement===panel.current)){event.preventDefault();last.focus();}
   else if(!event.shiftKey&&(document.activeElement===last||document.activeElement===panel.current)){event.preventDefault();first.focus();}
  };
  window.addEventListener('keydown',key,true);
  return()=>{window.removeEventListener('keydown',key,true);if(previous?.isConnected)previous.focus();};
 },[]);
 return <div className="welcome-scrim"><section className="welcome-card" ref={panel} role="dialog" aria-modal="true" aria-labelledby="welcome-title" aria-describedby="welcome-copy" tabIndex={-1}>
  <button type="button" className="welcome-close" aria-label="Close welcome" onClick={onClose}>×</button>
  <BrandLogo className="welcome-brand"/>
  <svg className="welcome-street" viewBox="0 0 520 390" aria-hidden="true"><use href="/guide/illustrations.svg#street"/></svg>
  <h1 id="welcome-title">Welcome to the street.</h1>
  <p id="welcome-copy">Tap a wall, make a mark, then hit Paint.{!signedIn&&<><br/>No account needed to try.</>}</p>
  <button type="button" className="welcome-start" onClick={onClose}>Start painting</button>
  <nav className="welcome-links" aria-label="Getting started"><a href={informationUrl('/how-to-play/')} target="_blank" rel="noopener noreferrer">How to play<span className="visually-hidden"> (opens in a new tab)</span></a><a href={informationUrl('/terms/#respect')} target="_blank" rel="noopener noreferrer">Community rules<span className="visually-hidden"> (opens in a new tab)</span></a></nav>
  <footer>{signedIn?<span>Your progress is connected to your account.</span>:<><span>Keep your progress.</span><button type="button" onClick={onAccount}>Create an account</button></>}</footer>
 </section></div>;
}
